import { description } from "./../../../../../pages/SW/SW02/presenter/ui/UI";
import { createSlice } from "@reduxjs/toolkit";

type ApproveConfirmModalSlice = {
  isVisible: boolean;
  title: string;
  description: string | string[];
};

const initialState: ApproveConfirmModalSlice = {
  isVisible: false,
  title: "提出確認",
  description: "このリクエストを承認してもよろしいですか?",
};

export const ApproveConfirmModalSlice = createSlice({
  name: "ApproveConfirmModalSlice",
  initialState,
  reducers: {
    showModalApproveConfirm: (state) => {
      state.isVisible = true;
    },
    setModalApproveConfirmDescription: (state, action) => {
      state.description = action.payload;
    },
    setModalApproveConfirmTitle: (state, action) => {
      state.title = action.payload;
    },
    resetApproveConfirmModal: () => initialState,
  },
});

export const { showModalApproveConfirm, resetApproveConfirmModal, setModalApproveConfirmDescription, setModalApproveConfirmTitle } =
  ApproveConfirmModalSlice.actions;
export default ApproveConfirmModalSlice.reducer;
